import * as React from 'react';
import { Visible, Invisible } from './Icons';
export var IconPassword = function (props) {
    var name = props.name, onClick = props.onClick, className = props.className;
    var iconHandler = React.useCallback(function (prev) { return onClick(!prev); }, []);
    return (React.createElement("div", { onClick: iconHandler, className: "icon-password-wrapper" }, name === 'unhide' ? (React.createElement(Visible, { className: className })) : (React.createElement(Invisible, { className: className }))));
};
